export const environment = {
  production: true,
  apiUrl: '$API_URL',
  clientId: '$CLIENT_ID',
  clientSecret: '$CLIENT_SECRET',
  trusted: '$TRUSTED_CLIENT',
  baseSite: '$BASE_SITE',
  basePath: '$BASE_PATH',
  idp: {
    clientId: '$IDP_CLIENT_ID',
    authority: '$IDP_AUTHORITY',
    baseUrl: '$IDP_BASE_URL',
    host: '$IDP_HOST'
  },
  project: 'FS',
  routes: {
    productBaseRoute: "",
    productRoutes: {
      productId: "",
      productComplete: ""
    },
    sitesBaseRoute: '',
    sitesRoutes: {
      siteId: "",
    },
    categoryBaseRoute: "",
    checkoutBaseRoute: "",
    checkoutRoutes: {
      register: "",
      address: "",
      delivery: "",
      payment: "",
      summary: "",
      confirmation: ""
    },
    authBaseRoute: "auth",
    privacyPolicyBaseRoute: "",
    legalNoticeBaseRoute: "",
    termsBaseRoute: "",
    basketBaseRoute: "",
    notfoundBaseRoute: "404",
    previewBaseRoute: "",
    registerBaseRoute: "",
    faqBaseRoute: "",
    cookieHintRoute: "",
    faqRoutes: {
      contactRoute: "",
      confirmRoute: ""
    },
    searchBaseRoute: ""
  }
};

